module.exports = __webpack_public_path__ + "img/sheep.ac5241e.png";